// eslint-disable
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';

import FullButton from '../buttons/Full';

import { sendNewsletter } from '../../lib/requests';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/newsletter-form.scss';

const propTypes = {
    intl: AppPropTypes.intl.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const NewsletterForm = ({ intl, className }) => {
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState(null);
    const [inputData, setInputData] = useState({ name: '', email: '', city: '' });

    const onNameChange = useCallback(
        e => {
            setInputData({ ...inputData, name: e.target.value });
        },
        [inputData, setInputData],
    );

    const onCityChange = useCallback(
        e => {
            setInputData({ ...inputData, city: e.target.value });
        },
        [inputData, setInputData],
    );

    const onEmailChange = useCallback(
        e => {
            setInputData({ ...inputData, email: e.target.value });
        },
        [inputData, setInputData],
    );

    const onSubmit = useCallback(() => {
        if (inputData.name && inputData.email) {
            sendNewsletter('/api/newsletter', inputData).then(succ => {
                if (succ) {
                    setMessage(intl.formatMessage({ id: 'content.email.success' }));
                    setInputData({ name: '', email: '', city: '' });
                    setSuccess(true);
                } else {
                    setMessage(intl.formatMessage({ id: 'content.email.error' }));
                }
            });
        } else {
            setMessage(intl.formatMessage({ id: 'content.email.fill' }));
        }
    }, [inputData, setInputData, setMessage, success, setSuccess]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {!success ? (
                <div className={styles.form}>
                    <input
                        className={styles.input}
                        type="text"
                        placeholder={intl.formatMessage({ id: 'content.email.name' })}
                        onChange={onNameChange}
                        value={inputData.name}
                    />
                    <input
                        className={styles.input}
                        type="text"
                        placeholder={intl.formatMessage({ id: 'content.email.city' })}
                        onChange={onCityChange}
                        value={inputData.city}
                    />
                    <input
                        className={styles.input}
                        type="text"
                        placeholder={intl.formatMessage({ id: 'content.email.email' })}
                        onChange={onEmailChange}
                        value={inputData.email}
                    />
                    <FullButton className={styles.send} highlighted onClick={onSubmit}>
                        {intl.formatMessage({ id: 'content.email.send' })}
                    </FullButton>
                </div>
            ) : null}
            {message ? <p className={styles.message}>{message}</p> : null}
        </div>
    );
};

NewsletterForm.propTypes = propTypes;
NewsletterForm.defaultProps = defaultProps;

export default injectIntl(NewsletterForm);
